<template>
  <rounded-card>
    <img class="mb-8" src="../../../assets/DefaultCloudzet/group-1063.svg" />
    <template v-if="type === 'email'">
      <h1 class="mb-1 text-xl">{{ $t('login.complete_email_reset_pwd_title') }}</h1>
      <div class="email-content text-xs text-center">
        {{ $t('login.sent_email') }} <span>{{ email }}</span
        >.
        <br />
        {{ $t('login.email_reset_pwd') }}
      </div>
      <div class="message mt-8 text-xs">
        {{ $t('login.get_the_code') }}
        <span
          class="timer inline-block ml-2 underline"
          :class="{ 'opacity-50': seconds }"
          @click="$emit('send')"
        >
          {{ $t('login.resend') }}
          <span v-if="seconds">({{ seconds }}s)</span>
        </span>
      </div>
    </template>
    <template v-else>
      <h1 class="mb-1 text-xl">{{ $t('login.complete_phone_reset_pwd_title') }}</h1>
      <div class="phone-content text-xs text-center" v-html="$t('login.login_new_password')" />
    </template>
    <c-button class="mt-10 mb-8" @click="$emit('set-show', false)">
      {{ $t('login.login_my_account') }}
    </c-button>
  </rounded-card>
</template>

<script>
import RoundedCard from '@/components/common/RoundedCard.vue';
import CButton from '@/components/common/CButton.vue';

export default {
  components: {
    RoundedCard,
    CButton,
  },
  props: {
    email: {
      type: String,
      default: '',
    },
    type: String,
  },
  data() {
    return {
      seconds: 60,
    };
  },
  mounted() {
    if (this.type === 'email') {
      this.setTimer();
    }
  },
  beforeDestroy() {
    if (this.type === 'email') {
      this.setTimer();
    }
  },
  methods: {
    setTimer() {
      if (!this.seconds) return;
      setTimeout(() => {
        this.seconds -= 1;
        this.setTimer();
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.email-content {
  width: 277px;

  span {
    color: #572bff;
  }
}

.message,
.phone-content {
  color: #6a6a6a;
}
</style>
